import { render, staticRenderFns } from "./SafetySettingsList.vue?vue&type=template&id=6895abdd"
import script from "./SafetySettingsList.vue?vue&type=script&lang=js"
export * from "./SafetySettingsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports